import React, { Fragment, useState, useEffect } from 'react'
import LeaveSiteWarning from '../../shared/LeaveSiteWarning'
import { useTranslation } from '../../../hooks/useTranslation'
import { getApi } from '~/util/api'
import { Button, Card, Typography } from '~/components/_atoms'
import { Stack } from '~/components/_layouts'
import Spinner from '~/components/shared/Spinner'

export function RecommendedJobsCard({ className }) {
  const { t } = useTranslation()

  let companyColors = ['#A93226', '#633974', '#1A5276']
  let companyColorMap = {}
  let colorIndex = 0
  const [isLoading, setIsLoading] = useState(false)
  const [recommendedJobs, setRecommendedJobs] = useState([])

  useEffect(() => {
    setIsLoading(true)
    getApi()
      .get('/recommended_jobs')
      .then((response) => {
        if (response.status == 200) {
          setRecommendedJobs(response.data)
          return
        } else {
          throw new Error('json request failed')
        }
      })
      .finally(() => {
        setIsLoading(false)
      })
      .catch((error) => {
        console.log('json request failed', error)
      })
  }, [setRecommendedJobs])

  return (
    <Card
      className={className}
      title={t('recommended_jobs_card.title')}
      actions={
        <div className="yns-stack flex flex-row flex-wrap items-center gap-2 ">
          {/*<div className="flex w-full flex-col gap-2 @sm:flex-row @sm:justify-between">
          <Button
            variant="ghost"
            size="sm"
            href="/job-search/boards"
            className="ga-trackable w-full @sm:w-auto"
          >
            {t('my_jobs_card.empty.action_job_board')}
          </Button> */}
          <Button
            variant="ghost"
            size="sm"
            href="/job-search/jobs"
            className="ga-trackable w-full @sm:w-auto"
          >
            {t('my_jobs_card.empty.action_search')}
          </Button>
        </div>
      }
    >
      <Stack spacing={3}>
        <Typography>{t('recommended_jobs_card.description')}</Typography>
        {isLoading ? (
          <div className="flex items-center justify-center">
            <Spinner show className="h-9 w-9" />
          </div>
        ) : (
          <Stack spacing={6}>
            {recommendedJobs.map((job, index) => {
              let companyColor = companyColorMap[job['company']]
              if (!companyColor) {
                companyColor = companyColors[colorIndex % companyColors.length]
                companyColorMap[job['company']] = companyColor
                colorIndex++
              }

              return (
                <Fragment key={`item-${index}`}>
                  {index > 0 && <hr />}
                  <div
                    key={`item-${index}`}
                    className="flex flex-col gap-3 @sm:flex-row @sm:items-center @sm:justify-between"
                  >
                    <div className="flex gap-3">
                      {job['logo'] ? (
                        <div>
                          <img
                            src={job['logo']}
                            alt={job['company']}
                            className="h-12 w-12 rounded-sm object-cover"
                          />
                        </div>
                      ) : (
                        <div className="col-span-2">
                          <div
                            className="flex h-12 w-12 flex-grow items-center justify-center rounded-sm text-2xl text-white"
                            style={{ backgroundColor: companyColor }}
                          >
                            {job['company']
                              ? job['company'][0]?.toUpperCase()
                              : '■'}
                          </div>
                        </div>
                      )}
                      <Stack>
                        <Typography className="font-bold">
                          {job['title']}
                        </Typography>
                        <Typography>
                          {job['company']}
                          {job['company'] && job['location'] ? ' - ' : ''}
                          {job['location']}
                        </Typography>
                      </Stack>
                    </div>
                    <div>
                      <LeaveSiteWarning url={job['url']}>
                        <Button variant="outline" size="sm">
                          {t('recommended_jobs_card.view_action')}
                        </Button>
                      </LeaveSiteWarning>
                    </div>
                  </div>
                </Fragment>
              )
            })}
          </Stack>
        )}
      </Stack>
    </Card>
  )
}
